import { CallIcon, HoldHandIcon, UndoIcon } from '@/assets/icons/icons';

export const getActionIcon = (actionType: string) => {
  switch (actionType) {
    case 'hold_at_carrier':
      return HoldHandIcon;

    case 'schedule_next_attempt':
    case 'reroute_alternate':
      return CallIcon;

    case 'return_to_shipper':
      return UndoIcon;

    default:
      return null;
  }
};
